import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <>
            <footer>
                <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 dark:bg-black border-t border-b border-gray-200 dark:border-[#262626] py-30">

                    {/* Top area: Blocks */}
                    <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 dark:border-[#262626] lg:ml-11">

                    {/* 1st block */}
                    <div className="col-span-12 lg:col-span-4">
                        <div className="box-border border-b-4 border-gray-900 dark:border-white p-8 bg-gray-200 dark:bg-[#111111] text-gray-600 dark:text-[#a1a1aa] text-center rounded-lg xl:w-80 mx-auto">
                            <img 
                                src="/logo_tomorrow.png" 
                                alt="Tomorrow Global" 
                                className="h-12 md:h-16 w-auto mx-auto mb-4 dark:brightness-0 dark:invert transition-all duration-300"
                            />
                            <div className='text-md font-medium text-gray-600 dark:text-[#a1a1aa]'>
                                <h5>Agence Média 360</h5>
                                <p className="mt-2 font-semibold">Tunis, Tunisia</p>
                                <p>Rue de l'Euro, Immeuble Selim</p>
                                <p>Les Berges Du Lac II, Tunis</p>
                                <p className="mt-2">+216 52 814 814</p>
                                <p className="mt-2 font-semibold">Montréal, Québec, Canada</p>
                                <p>1288, Rue Saint-Antoine Ouest</p>
                                <p>Montreal, H3C 1C2</p>
                                <p>+1 438 507 9996</p>
                            </div>
                        </div>
                    </div>

                    {/* 2nd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                        <h6 className="text-gray-900 dark:text-white text-xl font-bold mb-4">LIENS</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <HashLink to="#" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">À propos</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Services</HashLink>
                        </li>
                        <li className="mb-2">
                            <HashLink to="#" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Contact</HashLink>
                        </li>                            
                        </ul>
                    </div>

                    {/* 3rd block */}
                    <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                        <h6 className="text-gray-900 dark:text-white text-xl font-bold mb-4">NOS SERVICES</h6>
                        <ul className="text-md">
                        <li className="mb-2">
                            <Link to="/get-demo?service=achat-media" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Achat Media</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/get-demo?service=production-audiovisuelle" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Production Audiovisuelle</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/get-demo?service=digital-media" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Digital Media</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/get-demo?service=consulting-strategie" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Consulting & Stratégie</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/get-demo?service=design-creativite" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Design & Créativité</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/get-demo?service=evenementielle" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Événementielle</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/get-demo?service=animation-2d-3d" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Animation 2D & 3D</Link>
                        </li>
                        <li className="mb-2">
                            <Link to="/get-demo?service=influence-marketing" className="text-gray-700 dark:text-[#a1a1aa] hover:text-gray-900 dark:hover:text-white hover:tracking-wider transition duration-250 ease-in-out">Influence Marketing</Link>
                        </li>
                        </ul>
                    </div>

                    {/* 4th block */}
                    <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-gray-900 dark:text-white">
                        <div className="text-xl mb-6">
                            Liens des Réseaux Sociaux.
                        </div>

                                <div className="text-md font-medium mb-6 text-gray-700 dark:text-[#a1a1aa]">
                                    Suivez-nous sur les réseaux sociaux.
                                </div>
                        <div className="mx-auto text-center mt-2">
                                <ul className="flex justify-center mb-4 md:mb-0">
                                    <li>
                                        <Link to="#" className="flex justify-center items-center text-gray-900 dark:text-white hover:text-gray-600 dark:hover:text-[#a1a1aa] bg-white dark:bg-[#111111] hover:bg-gray-50 dark:hover:bg-[#171717] rounded-full shadow transition duration-150 ease-in-out border border-gray-200 dark:border-[#262626]" aria-label="Twitter">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                                        </svg>
                                        </Link>
                                    </li>
                                    <li className="ml-4">
                                        <Link to="#" className="flex justify-center items-center text-gray-900 dark:text-white hover:text-gray-600 dark:hover:text-[#a1a1aa] bg-white dark:bg-[#111111] hover:bg-gray-50 dark:hover:bg-[#171717] rounded-full shadow transition duration-150 ease-in-out border border-gray-200 dark:border-[#262626]" aria-label="Facebook">
                                        <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                                        </svg>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                    </div>          

                    </div>

                    <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
                <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                    <div className="text-sm text-gray-600 dark:text-[#71717a] font-semibold py-1">
                    Copyright &copy; {new Date().getFullYear()}{"  "}
                    <HashLink
                        to="#"
                        className="hover:text-gray-900 dark:hover:text-white"
                    >
                        Tomorrow Global
                    </HashLink>. Tous droits réservés.
                    </div>
                </div>
                </div>

                </div>
                
            </footer>
        </>
    )
}
export default Footer;
